import '@shopify/ui-extensions/preact';
import {render} from "preact";

const RATING_URL = "https://fogyasztobarat.hu";
const BARAT_ICON =
  "https://fogyasztobarat.hu/wp-content/themes/Fogyasztobarat/assets/images/yellow_design/logo/fogyaszto_barat_logo_sarga.svg";
const STAR_ROW = "★★★★★";

function generateFbToken(length = 32) {
  const alphabet =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  const bytes = crypto.getRandomValues(new Uint8Array(length));

  return Array.from(bytes, (byte) => alphabet[byte % alphabet.length]).join("");
}

export default async () => {
  render(<Extension />, document.body);
};

function Extension() {
  const ratingEnabledMetafield = shopify.appMetafields.value.find(
    (appMetafield) =>
      appMetafield.target.type === "shop" &&
      appMetafield.metafield.namespace === "$app" &&
      appMetafield.metafield.key === "rating_enabled",
  );

  if (ratingEnabledMetafield?.metafield?.value !== "true") {
    return null;
  }

  const widgetIdMetafield = shopify.appMetafields.value.find(
    (appMetafield) =>
      appMetafield.target.type === "shop" &&
      appMetafield.metafield.namespace === "$app" &&
      appMetafield.metafield.key === "widget_id",
  );

  const ratingUrl = new URL(RATING_URL);
  const storefrontUrl = shopify.shop?.storefrontUrl;
  const widgetId = widgetIdMetafield?.metafield?.value;
  const orderConfirmationId = shopify.orderConfirmation?.value?.id;
  const fbToken = generateFbToken();

  if (storefrontUrl) {
    ratingUrl.searchParams.set("url", storefrontUrl);
  }

  if (widgetId) {
    ratingUrl.searchParams.set("id", widgetId);
  }

  if (orderConfirmationId) {
    ratingUrl.searchParams.set("order_confirmation_id", orderConfirmationId);
  }

  ratingUrl.searchParams.set("fb_token", fbToken);

  return (
    <s-box
      background="subdued"
      border="base"
      borderRadius="large"
      padding="base"
    >
      <s-stack gap="base">
        <s-box
          background="base"
          border="base"
          borderRadius="base"
          padding="base"
        >
          <s-stack gap="base">
            <s-box inlineSize={24} blockSize={24}>
              <s-image
                src={BARAT_ICON}
                alt="Fogyasztó Barát"
                inlineSize="auto"
                objectFit="contain"
                borderRadius="small"
              />
            </s-box>

            <s-stack gap="tight">
              <s-text type="strong">Fogyasztó Barát</s-text>
              <s-text color="subdued">Megbízható vásárlói visszajelzés</s-text>
            </s-stack>

            <s-box
              background="subdued"
              border="base"
              borderRadius="base"
              padding="base"
            >
              <s-stack gap="tight">
                <s-text type="strong" tone="warning">{STAR_ROW}</s-text>
                <s-text type="strong">
                  Segíts jobbá tenni az oldalt egy rövid értékeléssel.
                </s-text>
                <s-text color="subdued">
                  Az értékelés a Fogyasztó Barát oldalán nyílik meg.
                </s-text>
              </s-stack>
            </s-box>
          </s-stack>
        </s-box>

        <s-button
          href={ratingUrl.toString()}
          target="_blank"
          variant="primary"
          inlineSize="fill"
        >
          Értékelés indítása
        </s-button>
      </s-stack>
    </s-box>
  );
}
